import { useSelector } from 'react-redux'
import { Box, Container, Typography } from '@mui/material';
import Header from '../../../../shared/components/Header'
import SubHeader from '../../../../shared/styles/Subheader'
import EventCalendar from '../../../../backoffice/events/ui/components/EventCalendar'
import ContentFilter from '../../../../shared/components/layouts/filters/ContentFilter'
import { IRootState } from '../../../../../redux/types'
import { useTranslation } from 'react-i18next'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'

function EventList() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)

  const { globalFamilyId, globalBrandId } = useSelector((state: IRootState) => state.global)
  return (
    <>
      <Header title={t('events')} />
      <SubHeader />
      <ContentFilter showOrderBy={false} goBackAction={true} />

      <Container maxWidth="lg">
        <Box mb={3} />
        {isMobile && (
          <Box pb={3}>
            <Typography variant="h6" align="center">
              t('events')
            </Typography>
          </Box>
        )}
        <EventCalendar fullHeight={true} family_id={globalFamilyId} brand_id={globalBrandId} />
      </Container>
    </>
  )
}

export default EventList
